import { Bar } from './bar';
import { Ribbon } from './ribbon';

export { BAR_HEIGHT } from './bar';
export const highlightElementsMap = {
  bar: Bar,
  ribbon: Ribbon
};
